import authApi from '@/app/common/api/authApi';
import IconAlert from '../../../components/common/IconAlert';
import { useSearchParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useRePaymentMutation } from '@/app/Purchase/api/ordersApi';
import { errorMessage } from '@/utils/toast';
import { Button, Spinner, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { OrderProps } from '../types/purchaseTypes';

function Payment({ isMemberStep = false }: OrderProps) {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    if (searchParams.get('status') === 'ok') {
      dispatch(authApi.util.invalidateTags(['UserInfo']));
    }
  }, [searchParams]);
  const [repayment, { isLoading: isRepaymenting }] = useRePaymentMutation();
  return (
    <Card className='p-4'>
      {searchParams.get('status') === 'ok' && (
        <IconAlert variant="success" className='mb-0'>
          <div className="d-flex flex-wrap  justify-content-between align-items-center">
            <div className="d-flex flex-column">
              <span className="fw-semi-bold">پرداخت با موفقیت انجام شد</span>
              <span className="mt-1 fs--1">
                طرح شما به‌روزرسانی شد و از این لحظه قابل استفاده است.
              </span>
            </div>
            {!isMemberStep ? (
              <Link to="/" className=" w-100 w-lg-auto mt-3 mt-lg-0">
                <Button
                  variant="falcon-primary"
                  className=" w-100 d-flex justify-content-center align-items-center w-lg-auto mt-3 mt-lg-0 fs--1"
                >
                  <FontAwesomeIcon className="me-1" icon="pie-chart" />
                  ورود به داشبورد
                </Button>
              </Link>
            ) : (
              <Link
                to="/membership-steps/domains"
                className=" w-100 w-lg-auto mt-3 mt-lg-0"
              >
                <Button
                  variant="falcon-primary"
                  className=" w-100 d-flex justify-content-center align-items-center w-lg-auto mt-3 mt-lg-0 fs--1"
                >
                  <FontAwesomeIcon className="me-1" icon="globe" />
                  افزودن دامنه‌ها
                </Button>
              </Link>
            )}
          </div>
        </IconAlert>
      )}
      {searchParams.get('status') === 'nook' && (
        <>
          <IconAlert variant="danger" className='mb-0'>
            <div className="d-flex flex-wrap  justify-content-between align-items-center">
              <div className="d-flex flex-column">
                <span className="fw-semi-bold">پرداخت ناموفق بود</span>
                <span className="mt-1 fs--1">
                  پرداخت تکمیل نشد. برای ادامه، دوباره به درگاه متصل شوید.
                </span>
              </div>
              <Button
                disabled={isRepaymenting}
                className=" w-100 d-flex justify-content-center align-items-center w-lg-auto mt-3 mt-lg-0 fs--1"
                onClick={() => {
                  repayment(isMemberStep ? 'membership' : 'prorogate')
                    .unwrap()
                    .then(response => {
                      if (response.success && typeof response.data === 'string') {
                        location.replace(response.data);
                      }
                    })
                    .catch(() => {
                      errorMessage('خطا در انتقال به صفحه پرداخت');
                    });
                }}
                variant="falcon-primary"
              >
                {isRepaymenting ? (
                  <>
                    <Spinner
                      style={{
                        width: '16px',
                        height: '16px'
                      }}
                      className="me-1"
                    />
                    درحال اتصال مجدد
                    <span className="d-md-inline d-none">
                      &nbsp;به درگاه پرداخت
                    </span>
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon className="me-1" icon="redo-alt" />
                    اتصال مجدد به درگاه پرداخت
                  </>
                )}
              </Button>
            </div>
          </IconAlert>
        </>
      )}
    </Card>
  );
};

export default Payment;
